import { render } from "./AvailabilityEditor.vue?vue&type=template&id=39caa840&scoped=true"
import script from "./AvailabilityEditor.vue?vue&type=script&lang=js"
export * from "./AvailabilityEditor.vue?vue&type=script&lang=js"

import "./AvailabilityEditor.vue?vue&type=style&index=0&id=39caa840&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39caa840"]])

export default __exports__